/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Mark_ShippedInputs */

const en_samples_mark_shipped = /** @type {(inputs: Samples_Mark_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark Shipped`)
};

const es_samples_mark_shipped = /** @type {(inputs: Samples_Mark_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar enviado`)
};

/**
* | output |
* | --- |
* | "Mark Shipped" |
*
* @param {Samples_Mark_ShippedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_mark_shipped = /** @type {((inputs?: Samples_Mark_ShippedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Mark_ShippedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_mark_shipped(inputs)
	return es_samples_mark_shipped(inputs)
});